/**
 * Patient Import Store Hooks
 *
 * Re-exports generated data-migration hooks with user-friendly names.
 * The verbose codegen names (e.g. useProviderGetProposedSchemaQuery) are
 * never exposed outside this module.
 */

import {
  patientImportApi,
  useApproveReviewMutation,
  useUploadPatientImportFileMutation,
} from './api';

// ---------------------------------------------------------------------------
// Destructure generated hooks from the enhanced API
// ---------------------------------------------------------------------------

const {
  useGetReviewPatientsQuery,
  useGetReviewSummaryQuery,
  useProviderDeleteImportSessionMutation,
  useProviderGetImportSessionStatusQuery,
  useProviderListImportSessionsQuery,
} = patientImportApi;

// ---------------------------------------------------------------------------
// Re-export with user-friendly names
// ---------------------------------------------------------------------------

export {
  // Review wizard endpoints (phased BE endpoints)
  useApproveReviewMutation,
  // Shared endpoints
  useProviderDeleteImportSessionMutation as useDeleteImportSessionMutation,
  useProviderGetImportSessionStatusQuery as useGetImportSessionStatusQuery,
  useGetReviewPatientsQuery as useGetReviewPhaseQuery,
  useGetReviewSummaryQuery,
  useProviderListImportSessionsQuery as useListImportSessionsQuery,
  useUploadPatientImportFileMutation as useUploadImportFileMutation,
};
